import type { MailboxInfo } from 'owa-client-types';
import type { Module } from 'owa-workloads-module';
import { getGlobalSettingsAccountMailboxInfo } from 'owa-account-source-list-store';
import getModuleContextMailboxInfoStore from '../store/moduleContextMailboxInfoStore';

/**
 * Returns the mailbox info bound to the given module, or the global settings account
 * if the module has no specific binding. Use this when callers need the mailbox for a
 * *target* module that may differ from the currently-active module — e.g. inside an
 * `onModuleClick` orchestrator, where the module store has not yet updated to the
 * clicked module at the time the handler runs.
 */
export default function getMailboxInfoForModule(module: Module): MailboxInfo {
    const mailboxInfo = getModuleContextMailboxInfoStore().moduleContextMailboxInfos.get(module);
    return mailboxInfo ?? getGlobalSettingsAccountMailboxInfo();
}
